import React from 'react'
import SalaryGenerateListTable from './components/SalaryGenerateListTable'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { NavLink } from 'react-router-dom';
import { GetPageUrl } from "utils/CommonUtils";

const SalaryGenerateList = () => {
    const pageUrl = GetPageUrl();
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Salary Generate List</HeadingOne>
                    <div className="d-flex gap-2">
                        <NavLink to={`/admin/${pageUrl}/edit-salary-generate-status`} className="btn btn-primary">
                            Update Salary Status
                        </NavLink>
                        <AddItemBtn url="add-salary-generate" title="Generate Salary Sheet" />
                    </div>
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <SalaryGenerateListTable />
            </div>
        </PageBody>
    );
};

export default SalaryGenerateList;
